import _toConsumableArray from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/createClass.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { getClient, getCurrentScope } from '../currentScopes.js';
import { DEBUG_BUILD } from '../debug-build.js';
import { createSpanEnvelope } from '../envelope.js';
import { SEMANTIC_ATTRIBUTE_SENTRY_OP, SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, SEMANTIC_ATTRIBUTE_SENTRY_SOURCE, SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME, SEMANTIC_ATTRIBUTE_PROFILE_ID, SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME } from '../semanticAttributes.js';
import { debug } from '../utils/debug-logger.js';
import { generateTraceId, generateSpanId } from '../utils/propagationContext.js';
import { TRACE_FLAG_SAMPLED, TRACE_FLAG_NONE, spanTimeInputToSeconds, convertSpanLinksForEnvelope, getRootSpan, getStatusMessage, spanToJSON, getSpanDescendants, spanToTransactionTraceContext } from '../utils/spanUtils.js';
import { timestampInSeconds } from '../utils/time.js';
import { getDynamicSamplingContextFromSpan } from './dynamicSamplingContext.js';
import { logSpanEnd } from './logSpans.js';
import { timedEventsToMeasurements } from './measurement.js';
import { getCapturedScopesOnSpan } from './utils.js';
var MAX_SPAN_COUNT = 1000;

/**
 * Span contains all data about a span
 */
var SentrySpan = /*#__PURE__*/function () {
  /** Epoch timestamp in seconds when the span started. */

  /** Epoch timestamp in seconds when the span ended. */

  /** Internal keeper of the status */

  /** The timed events added to this span. */

  /** if true, treat span as a standalone span (not part of a transaction) */

  /**
   * You should never call the constructor manually, always use `Sentry.startSpan()`
   * or other span methods.
   * @internal
   * @hideconstructor
   * @hidden
   */
  function SentrySpan() {
    var spanContext = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, SentrySpan);
    this._traceId = spanContext.traceId || generateTraceId();
    this._spanId = spanContext.spanId || generateSpanId();
    this._startTime = spanContext.startTimestamp || timestampInSeconds();
    this._links = spanContext.links;
    this._attributes = {};
    this.setAttributes(_objectSpread(_defineProperty(_defineProperty({}, SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, 'manual'), SEMANTIC_ATTRIBUTE_SENTRY_OP, spanContext.op), spanContext.attributes));
    this._name = spanContext.name;
    if (spanContext.parentSpanId) {
      this._parentSpanId = spanContext.parentSpanId;
    }
    // We want to include booleans as well here
    if ('sampled' in spanContext) {
      this._sampled = spanContext.sampled;
    }
    if (spanContext.endTimestamp) {
      this._endTime = spanContext.endTimestamp;
    }
    this._events = [];
    this._isStandaloneSpan = spanContext.isStandalone;

    // If the span is already ended, ensure we finalize the span immediately
    if (this._endTime) {
      this._onSpanEnded();
    }
  }

  /** @inheritDoc */
  return _createClass(SentrySpan, [{
    key: "addLink",
    value: function addLink(link) {
      if (this._links) {
        this._links.push(link);
      } else {
        this._links = [link];
      }
      return this;
    }

    /** @inheritDoc */
  }, {
    key: "addLinks",
    value: function addLinks(links) {
      if (this._links) {
        var _this$_links;
        (_this$_links = this._links).push.apply(_this$_links, _toConsumableArray(links));
      } else {
        this._links = links;
      }
      return this;
    }

    /**
     * This should generally not be used,
     * but it is needed for being compliant with the OTEL Span interface.
     *
     * @hidden
     * @internal
     */
  }, {
    key: "recordException",
    value: function recordException(_exception, _time) {
      // noop
    }

    /** @inheritdoc */
  }, {
    key: "spanContext",
    value: function spanContext() {
      var spanId = this._spanId,
        traceId = this._traceId,
        sampled = this._sampled;
      return {
        spanId: spanId,
        traceId: traceId,
        traceFlags: sampled ? TRACE_FLAG_SAMPLED : TRACE_FLAG_NONE
      };
    }

    /** @inheritdoc */
  }, {
    key: "setAttribute",
    value: function setAttribute(key, value) {
      if (value === undefined) {
        // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._attributes[key];
      } else {
        this._attributes[key] = value;
      }
      return this;
    }

    /** @inheritdoc */
  }, {
    key: "setAttributes",
    value: function setAttributes(attributes) {
      var _this = this;
      Object.keys(attributes).forEach(function (key) {
        return _this.setAttribute(key, attributes[key]);
      });
      return this;
    }

    /**
     * This should generally not be used,
     * but we need it for browser tracing where we want to adjust the start time afterwards.
     * USE THIS WITH CAUTION!
     *
     * @hidden
     * @internal
     */
  }, {
    key: "updateStartTime",
    value: function updateStartTime(timeInput) {
      this._startTime = spanTimeInputToSeconds(timeInput);
    }

    /**
     * @inheritDoc
     */
  }, {
    key: "setStatus",
    value: function setStatus(value) {
      this._status = value;
      return this;
    }

    /**
     * @inheritDoc
     */
  }, {
    key: "updateName",
    value: function updateName(name) {
      this._name = name;
      this.setAttribute(SEMANTIC_ATTRIBUTE_SENTRY_SOURCE, 'custom');
      return this;
    }

    /** @inheritdoc */
  }, {
    key: "end",
    value: function end(endTimestamp) {
      // If already ended, skip
      if (this._endTime) {
        return;
      }
      this._endTime = spanTimeInputToSeconds(endTimestamp);
      logSpanEnd(this);
      this._onSpanEnded();
    }

    /**
     * Get JSON representation of this span.
     *
     * @hidden
     * @internal This method is purely for internal purposes and should not be used outside
     * of SDK code. If you need to get a JSON representation of a span,
     * use `spanToJSON(span)` instead.
     */
  }, {
    key: "getSpanJSON",
    value: function getSpanJSON() {
      return {
        data: this._attributes,
        description: this._name,
        op: this._attributes[SEMANTIC_ATTRIBUTE_SENTRY_OP],
        parent_span_id: this._parentSpanId,
        span_id: this._spanId,
        start_timestamp: this._startTime,
        status: getStatusMessage(this._status),
        timestamp: this._endTime,
        trace_id: this._traceId,
        origin: this._attributes[SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN],
        profile_id: this._attributes[SEMANTIC_ATTRIBUTE_PROFILE_ID],
        exclusive_time: this._attributes[SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME],
        measurements: timedEventsToMeasurements(this._events),
        is_segment: this._isStandaloneSpan && getRootSpan(this) === this || undefined,
        segment_id: this._isStandaloneSpan ? getRootSpan(this).spanContext().spanId : undefined,
        links: convertSpanLinksForEnvelope(this._links)
      };
    }

    /** @inheritdoc */
  }, {
    key: "isRecording",
    value: function isRecording() {
      return !this._endTime && !!this._sampled;
    }

    /**
     * @inheritdoc
     */
  }, {
    key: "addEvent",
    value: function addEvent(name, attributesOrStartTime, startTime) {
      DEBUG_BUILD && debug.log('[Tracing] Adding an event to span:', name);
      var time = isSpanTimeInput(attributesOrStartTime) ? attributesOrStartTime : startTime || timestampInSeconds();
      var attributes = isSpanTimeInput(attributesOrStartTime) ? {} : attributesOrStartTime || {};
      var event = {
        name: name,
        time: spanTimeInputToSeconds(time),
        attributes: attributes
      };
      this._events.push(event);
      return this;
    }

    /**
     * This method should generally not be used,
     * but for now we need a way to publicly check if the `_isStandaloneSpan` flag is set.
     * USE THIS WITH CAUTION!
     * @internal
     * @hidden
     * @experimental
     */
  }, {
    key: "isStandaloneSpan",
    value: function isStandaloneSpan() {
      return !!this._isStandaloneSpan;
    }

    /** Emit `spanEnd` when the span is ended. */
  }, {
    key: "_onSpanEnded",
    value: function _onSpanEnded() {
      var client = getClient();
      if (client) {
        client.emit('spanEnd', this);
      }

      // A segment span is basically the root span of a local span tree.
      // So for now, this is either what we previously refer to as the root span,
      // or a standalone span.
      var isSegmentSpan = this._isStandaloneSpan || this === getRootSpan(this);
      if (!isSegmentSpan) {
        return;
      }

      // if this is a standalone span, we send it immediately
      if (this._isStandaloneSpan) {
        if (this._sampled) {
          sendSpanEnvelope(createSpanEnvelope([this], client));
        } else {
          DEBUG_BUILD && debug.log('[Tracing] Discarding standalone span because its trace was not chosen to be sampled.');
          if (client) {
            client.recordDroppedEvent('sample_rate', 'span');
          }
        }
        return;
      }
      var transactionEvent = this._convertSpanToTransaction();
      if (transactionEvent) {
        var scope = getCapturedScopesOnSpan(this).scope || getCurrentScope();
        scope.captureEvent(transactionEvent);
      }
    }

    /**
     * Finish the transaction & prepare the event to send to Sentry.
     */
  }, {
    key: "_convertSpanToTransaction",
    value: function _convertSpanToTransaction() {
      var _capturedSpanScope$ge,
        _this2 = this;
      // We can only convert finished spans
      if (!isFullFinishedSpan(spanToJSON(this))) {
        return undefined;
      }
      if (!this._name) {
        DEBUG_BUILD && debug.warn('Transaction has no name, falling back to `<unlabeled transaction>`.');
        this._name = '<unlabeled transaction>';
      }
      var _getCapturedScopesOnS = getCapturedScopesOnSpan(this),
        capturedSpanScope = _getCapturedScopesOnS.scope,
        capturedSpanIsolationScope = _getCapturedScopesOnS.isolationScope;
      var normalizedRequest = capturedSpanScope === null || capturedSpanScope === void 0 || (_capturedSpanScope$ge = capturedSpanScope.getScopeData().sdkProcessingMetadata) === null || _capturedSpanScope$ge === void 0 ? void 0 : _capturedSpanScope$ge.normalizedRequest;
      if (this._sampled !== true) {
        return undefined;
      }

      // The transaction span itself as well as any potential standalone spans should be filtered out
      var finishedSpans = getSpanDescendants(this).filter(function (span) {
        return span !== _this2 && !isStandaloneSpan(span);
      });
      var spans = finishedSpans.map(function (span) {
        return spanToJSON(span);
      }).filter(isFullFinishedSpan);
      var source = this._attributes[SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];

      // remove internal root span attributes we don't need to send.
      /* eslint-disable @typescript-eslint/no-dynamic-delete */
      delete this._attributes[SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME];
      spans.forEach(function (span) {
        delete span.data[SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME];
      });
      // eslint-enabled-next-line @typescript-eslint/no-dynamic-delete

      var transaction = _objectSpread({
        contexts: {
          trace: spanToTransactionTraceContext(this)
        },
        spans:
        // spans.sort() mutates the array, but `spans` is already a copy so we can safely do this here
        // we do not use spans anymore after this point
        spans.length > MAX_SPAN_COUNT ? spans.sort(function (a, b) {
          return a.start_timestamp - b.start_timestamp;
        }).slice(0, MAX_SPAN_COUNT) : spans,
        start_timestamp: this._startTime,
        timestamp: this._endTime,
        transaction: this._name,
        type: 'transaction',
        sdkProcessingMetadata: {
          capturedSpanScope: capturedSpanScope,
          capturedSpanIsolationScope: capturedSpanIsolationScope,
          dynamicSamplingContext: getDynamicSamplingContextFromSpan(this)
        },
        request: normalizedRequest
      }, source && {
        transaction_info: {
          source: source
        }
      });
      var measurements = timedEventsToMeasurements(this._events);
      var hasMeasurements = measurements && Object.keys(measurements).length;
      if (hasMeasurements) {
        DEBUG_BUILD && debug.log('[Measurements] Adding measurements to transaction event', JSON.stringify(measurements, undefined, 2));
        transaction.measurements = measurements;
      }
      return transaction;
    }
  }]);
}();
function isSpanTimeInput(value) {
  return value && typeof value === 'number' || value instanceof Date || Array.isArray(value);
}

// We want to filter out any incomplete SpanJSON objects
function isFullFinishedSpan(input) {
  return !!input.start_timestamp && !!input.timestamp && !!input.span_id && !!input.trace_id;
}

/** `SentrySpan`s can be sent as a standalone span rather than belonging to a transaction */
function isStandaloneSpan(span) {
  return span instanceof SentrySpan && span.isStandaloneSpan();
}

/**
 * Sends a `SpanEnvelope`.
 *
 * Note: If the envelope's spans are dropped, e.g. via `beforeSendSpan`,
 * the envelope will not be sent either.
 */
function sendSpanEnvelope(envelope) {
  var client = getClient();
  if (!client) {
    return;
  }
  var spanItems = envelope[1];
  if (!spanItems || spanItems.length === 0) {
    client.recordDroppedEvent('before_send', 'span');
    return;
  }

  // sendEnvelope should not throw
  // eslint-disable-next-line @typescript-eslint/no-floating-promises
  client.sendEnvelope(envelope);
}
export { SentrySpan };